<template>
    <YearPickerGrid
        :class="cn('w-full table-fixed border-separate border-spacing-x-0 border-spacing-y-2', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </YearPickerGrid>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { YearPickerGridProps } from 'reka-ui';
import { YearPickerGrid, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<YearPickerGridProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
